var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowsTopAndBottom = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.84633 18.4679C2.53834 18.1745 2.03899 18.1745 1.731 18.4679C1.42301 18.7613 1.42301 19.2369 1.731 19.5303L6.19234 23.78C6.50033 24.0734 6.99968 24.0734 7.30767 23.78L11.769 19.5303C12.077 19.2369 12.077 18.7613 11.769 18.4679C11.461 18.1745 10.9617 18.1745 10.6537 18.4679L7.48264 21.4885L7.48264 0.751258C7.48264 0.336357 7.12954 1.33514e-05 6.69398 1.33514e-05C6.25841 1.41561e-05 5.90532 0.336357 5.90532 0.751258L5.90532 21.3817L2.84633 18.4679ZM21.1537 5.53215C21.4617 5.82553 21.961 5.82553 22.269 5.53215C22.577 5.23877 22.577 4.76311 22.269 4.46973L17.8077 0.220048C17.4997 -0.0733316 17.0003 -0.0733313 16.6923 0.220048L12.231 4.46973C11.923 4.76311 11.923 5.23877 12.231 5.53215C12.539 5.82553 13.0383 5.82553 13.3463 5.53215L16.5174 2.51156V23.2488C16.5174 23.6637 16.8705 24 17.306 24C17.7416 24 18.0947 23.6637 18.0947 23.2488L18.0947 2.61829L21.1537 5.53215Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowsTopAndBottom);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrows-top-and-bottom.4f147cd2cb3f11b36089ef1fbfc59f7e.svg";